export default "__VITE_ASSET__ClWDNMda__"